import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { getUser, getUserStatus } from "../../userSlice";
import { useSelector } from "react-redux";
import { CODES } from "../../../consts/codes";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { ConfInfonavitRequestsForm } from "../../../components/common/infonavit/ConfInfonavitRequestsForm";
import { GetCredentialsNrps } from "../../../services/user/infonavit/adminCredentials";

export const AdminAutomaticRequests = () => {
  const userInfo = useSelector(getUser);
  const userStatus = useSelector(getUserStatus);

  // Estados
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [data, setData] = useState([]);

  const { t } = useTranslation();

  /**
   * Use Effect
   */
  /**
   * Carga los NRPs
   */
  useEffect(() => {
    if (userStatus === "succeeded") fetchNrps();
  }, [userStatus]);

  /**
   * Función que consulta y settea la información de los NRPs
   */
  const fetchNrps = async () => {
    try {
      setIsLoadingData(true);

      const mainUser = userInfo.mainUser;
      const {
        status,
        data: { responseStatus, response },
      } = await GetCredentialsNrps(mainUser);

      if (
        status === CODES.COD_RESPONSE_HTTP_OK &&
        responseStatus.statusCode === CODES.S_COD_RESPONSE_SUCCESS_REQUEST
      ) {
        setData(
          response.map((row, index) => {
            return { label: row.nrp, value: row.nrp };
          })
        );
      } else {
        setData([]);
      }

      setIsLoadingData(false);
    } catch (error) {
      console.log("====================================");
      console.log(error);
      console.log("====================================");
    }
  };

  return (
    <Grid
      container
      gap="3rem"
      padding={{
        xs: "1.8rem 2rem",
        sm: "2.6rem 3rem",
        md: "2.6rem 3rem",
        lg: "2.6rem 4.5rem",
        xl: "4.5rem",
      }}
    >
      <Grid item xs={12}>
        <p className="display-large__primary-one">
          {t("App.infonavitRequestsConf.title")}
        </p>
      </Grid>

      <Grid item xs={12}>
        <Grid
          container
          className="companies_info_container"
          direction="column"
          gap={2}
          padding="1.5rem"
        >
          <Grid item>
            <Grid container direction="row" alignItems="center">
              <Grid item>
                <ManageAccountsIcon className="accordion__upload__consultIcon" />
              </Grid>

              <Grid item className="col-flex">
                <p
                  className="display-small__primary-one"
                  style={{ paddingLeft: "1rem" }}
                >
                  {t("App.infonavitRequestsConf.subtitle")}
                </p>
              </Grid>
            </Grid>
          </Grid>

          <Grid item>
            <ConfInfonavitRequestsForm
              nrpsData={data}
              isLoadingData={isLoadingData}
              setIsLoadingData={setIsLoadingData}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
